import { render, staticRenderFns } from "./officialVehiclesListDetail.vue?vue&type=template&id=39d83e7b&"
import script from "./officialVehiclesListDetail.vue?vue&type=script&lang=js&"
export * from "./officialVehiclesListDetail.vue?vue&type=script&lang=js&"
import style0 from "./officialVehiclesListDetail.vue?vue&type=style&index=0&id=39d83e7b&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports